/**
 * Vue 3 migration note:
 * Vuex 3 (`new Vuex.Store()` + `Vue.use(Vuex)`) -> Vuex 4 (`createStore()`).
 * State / mutations / getters / actions bodies are unchanged. Only the
 * construction API and the `changeLocale` action (vue-i18n 9 uses
 * `i18n.global.locale`) were updated.
 */
import { createStore } from "vuex";
import VuexPersist from "vuex-persist";
import i18n, { selectedLocale } from "@/plugins/i18n";

const vuexPersist = new VuexPersist({
	key: "my-app",
	storage: window.localStorage
});

export default createStore({
	state: {
		clonedTemplateMasterDetails: {},
		bulkUploadProgress: {},
		adminTourSeen: "",
		customDomain: "",
		feedbackLastSession: {},
		AdditionalMenu: [],
		DefaultLoginLandingPage: "",
		ClientLobbyHTML: "",
		historyLandinURL: "",
		eventDefaultSessionPage: "",
		loggedInDeviceToken: "",
		staySignedIn: false,
		historyEvent: "",
		ClickToJoinText: "",
		userRole: "",
		AdminRoles: [],
		userId: "",
		token: "",
		getPopupNotification: false,
		EventBannerRedirect: "",
		EventFont: [{ FontPath: "", FontFamily: "" }],
		EventBranding: [
			{
				eventLogo: "",
				eventBGImage: "",
				banner: "",
				mobileBanner: "",
				shareBanner: "",
				topBar: "",
				headerBar: "",
				fontBar: "",
				sideNavigationAndIconColor: "",
				themeName: ""
			}
		],
		user: [
			{
				id: "",
				Email: "",
				name: "",
				fname: "",
				lname: "",
				profilepic: "",
				company: "",
				title: "",
				phone: "",
				roles: []
			}
		],
		client: [{ id: "", name: "" }],
		eventid: "",
		eventCount: 0,
		branding: [{ bg: "", logo: "", favicon: "", bg2: "", banner: "", mobileBanner: "", shareBanner: "", bodyTextColor: "" }],
		socialauth: [{ fb: "", google: "", linkedin: "" }],
		eventcollectionname: "",
		publicEventCollection: "",
		attendeeid: "",
		eventname: "",
		eventsdate: "",
		eventedate: "",
		tzone: "",
		selExhibitorID: "",
		selSponsorID: "",
		exbList: "",
		navProtectedExbList: [{ id: "", name: "", nav: "" }],
		sponsordetails: false,
		lobbyLoaded: false,
		loading: false,
		advExpo: false,
		expoToolTip: true,
		validateURL: false,
		urlReq: "",
		totalExpoBoothCount: 0,
		userChatLanguage: "",
		DefaultChatRoomId: null,
		MeetingSettings: [
			{
				Slot: "",
				StartDate: "",
				EndDate: "",
				AvailabilityFromTime: "",
				AvailabilityToTime: "",
				ButtonLabel: "",
				Items: []
			}
		],
		ShowNotification: false,
		loginType: "",
		ClientIP: "",
		PollAns: [{ id: "", ans: "" }],
		MappedEvent: [],
		locale: selectedLocale,
		IsMouseCursorEnabled: false,
		pollList: [{ id: "" }],
		currentPoll: "",
		AgoraPlayerBrowserSupportInIPad: false,
		AgoraPlayerBrowserSupportInMobile: false,
		currentLoginTime: null,
		isClientEventBrandingEnabled: false,
		brandingJsonUrl: null,
		version: null,
		previewLogin: null,
		IsAccessCodeLogin: false,
		isSSO: false,
		videoPlaySettings: null,
		alEmail: "",
		fbAccessToken: "",
		tempAdminEvent: {},
		EnableSelfService: false,
		DefaultLandingPageInsideEvent: "",
		SocialShareImage: null,
		IsStageChatEnabled: false,
		RouteName: "",
	},
	mutations: {
		setStageViewChat(state, val) {
			state.IsStageChatEnabled = val;
		},
		setEventocialShareImage(state, val) {
			state.SocialShareImage = val;
		},
		setDefaultLandingPageInsideEvent(state, val) {
			state.DefaultLandingPageInsideEvent = val;
		},
		setClonedTemplateMasterDetails(state, val) {
			state.clonedTemplateMasterDetails = val;
		},
		setBulkUploadProgress(state, val) {
			state.bulkUploadProgress = val;
		},
		setAdminTour(state, val) {
			state.adminTourSeen = val;
		},
		setCustomDomain(state, val) {
			state.customDomain = val;
		},
		setTempAdminEvent(state, val) {
			state.tempAdminEvent = val;
		},
		setFBAccessToken(state, val) {
			state.fbAccessToken = val;
		},
		setALEmail(state, val) {
			state.alEmail = val;
		},
		setVideoPlaySettings(state, val) {
			state.videoPlaySettings = val;
		},
		setDefaultRoomId(state, val) {
			state.DefaultChatRoomId = val;
		},
		setFeedbackLastSession(state, val) {
			state.feedbackLastSession = val;
		},
		setIsAccessCodeLogin(state, val) {
			state.IsAccessCodeLogin = val;
		},
		setPreviewLogin(state, val) {
			state.previewLogin = val;
		},
		setVersion(state, val) {
			state.version = val;
		},
		setDefaultLoginLandingPage(state, val) {
			state.DefaultLoginLandingPage = val;
		},
		setEventDefaultSessionPage(state, val) {
			state.eventDefaultSessionPage = val;
		},
		addToken(state, val) {
			state.token = val;
		},
		updateLocale(state, newLocale) {
			state.locale = newLocale;
		},
		AddloggedInDeviceToken(state, loggedinDeviceTokn) {
			state.loggedInDeviceToken = loggedinDeviceTokn;
		},
		GetPopupNotification(state, getPopupNotification) {
			state.getPopupNotification = getPopupNotification;
		},
		setClickToJoinText(state, clickToJoinText) {
			state.ClickToJoinText = clickToJoinText;
		},
		AddEventBannerRedirect(state, redirectUrl) {
			state.EventBannerRedirect = redirectUrl;
		},
		AddEventFont(state, fonts) {
			state.EventFont = [];
			state.EventFont.push(fonts);
		},
		addUser(state, usr) {
			state.user = [usr];
			//state.user.push(usr)
		},
		addIsSSO(state, data) {
			state.isSSO = data;
		},
		addClientID(state, clt) {
			state.client = [];
			state.client.push(clt);
		},
		addEventID(state, ID) {
			state.eventid = ID;
		},
		addEventCount(state, count) {
			state.eventCount = count;
		},
		addExpoBoothCount(state, count) {
			state.totalExpoBoothCount = count;
		},
		addBranding(state, brand) {
			state.branding = [];
			state.branding.push(brand);
		},
		addEventBranding(state, brand) {
			state.EventBranding = [];
			state.EventBranding.push(brand);
		},
		addAuth(state, auth) {
			state.socialauth = [];
			state.socialauth.push(auth);
		},
		addEventCollection(state, ID) {
			state.eventcollectionname = ID;
		},
		setPublicEventCollection(state, ID) {
			state.publicEventCollection = ID;
		},
		addAttendeeID(state, ID) {
			state.attendeeid = ID;
		},
		addEventName(state, ID) {
			state.eventname = ID;
		},
		addEventSdate(state, ID) {
			state.eventsdate = ID;
		},
		addEventEdate(state, ID) {
			state.eventedate = ID;
		},
		addExhibitorID(state, ID) {
			state.selExhibitorID = ID;
		},
		addUserChatLanguage(state, language) {
			state.userChatLanguage = language;
		},
		addSponsorID(state, ID) {
			state.selSponsorID = ID;
		},
		addZone(state, zone) {
			state.tzone = zone;
		},
		addExbList(state, str) {
			state.exbList = "";
			state.exbList = str;
		},
		addNavProtectedExbList(state, ex) {
			if (ex.id && ex.name) {
				var foundList = state.navProtectedExbList.filter(function (item) {
					return item.id == ex.id;
				});
				if (foundList.length == 0) {
					state.navProtectedExbList.push({ id: ex.id, name: ex.name, nav: ex.nav ? ex.nav : "" });
				}
			}
		},
		addSponsorDetails(state, flg) {
			state.sponsordetails = flg;
		},
		addMeetingSettings(state, MeetingSettings) {
			state.MeetingSettings = [];
			state.MeetingSettings.push(MeetingSettings);
		},
		Lobbyloaded(state, flg) {
			state.lobbyLoaded = flg;
		},
		setLoading(state, bool) {
			state.loading = bool;
		},
		setAdvExpo(state, bool) {
			state.advExpo = bool;
		},
		setExpoToolTip(state, bool) {
			state.expoToolTip = bool;
		},
		setMouseCursor(state, bool) {
			state.IsMouseCursorEnabled = bool;
		},
		setUrlReq(state, val) {
			state.urlReq = val;
		},
		setValidated(state, val) {
			state.validateURL = val;
		},
		setNotification(state, flg) {
			state.ShowNotification = flg;
		},
		setLoginType(state, val) {
			state.loginType = val;
		},
		setClientIP(state, val) {
			state.ClientIP = val;
		},
		setPollAns(state, val) {
			//state.PollAns = [];
			state.PollAns.push(val);
		},
		setMappedEvent(state, val) {
			state.MappedEvent = val;
		},
		clearMappedEvent(state) {
			state.MappedEvent = [];
		},
		setCurrentPoll(state, val) {
			state.currentPoll = val;
		},
		setPollList(state, val) {
			state.pollList.push(val);
		},
		setPlayerForIPad(state, bool) {
			state.AgoraPlayerBrowserSupportInIPad = bool;
		},
		setPlayerForMobile(state, bool) {
			state.AgoraPlayerBrowserSupportInMobile = bool;
		},
		setCurrentLoggedInTime(state, val) {
			state.currentLoginTime = val;
		},
		setClientEventBranding(state, val) {
			state.isClientEventBrandingEnabled = val;
		},
		setBrandingJsonUrl(state, val) {
			state.brandingJsonUrl = val;
		},
		setAdminRoles(state, val) {
			state.AdminRoles = val;
		},
		setEnableSelfService(state, val) {
			if (val == true) {
				state.EnableSelfService = true;
			}
			else {
				state.EnableSelfService = false;
			}
		},
		setRouteName(state, val) {
			if (val) {
				state.RouteName = val;
			}
			else {
				state.RouteName = "";
			}
		},
		ClearState(state) {
			state.IsStageChatEnabled = false;
			state.SocialShareImage = null;
			state.DefaultLandingPageInsideEvent = "";
			state.clonedTemplateMasterDetails = {};
			state.bulkUploadProgress = {};
			state.adminTourSeen = "";
			state.customDomain = "";
			state.IsAccessCodeLogin = false;
			state.AdditionalMenu = [];
			state.DefaultLoginLandingPage = "";
			state.ClientLobbyHTML = "";
			state.historyLandinURL = "";
			state.historyEvent = "";
			state.staySignedIn = false;
			state.userRole = "";
			state.AdminRoles = [];
			state.userId = "";
			state.eventDefaultSessionPage = "";
			state.loggedInDeviceToken = "";
			state.getPopupNotification = false;
			state.EventBannerRedirect = "";
			state.ClickToJoinText = "";
			state.EventFont = [];
			state.user = [];
			state.client = [];
			state.eventid = "";
			state.branding = [];
			state.socialauth = [];
			state.eventcollectionname = "";
			state.publicEventCollection = "";
			state.attendeeid = "";
			state.eventname = "";
			state.eventsdate = "";
			state.eventedate = "";
			state.selExhibitorID = "";
			state.userChatLanguage = "";
			state.selSponsorID = "";
			state.tzone = "";
			state.exbList = "";
			state.navProtectedExbList = [];
			state.sponsordetails = false;
			state.lobbyLoaded = false;
			state.EventBranding = [];
			state.loading = false;
			state.advExpo = false;
			state.expoToolTip = true;
			state.MeetingSettings = [];
			state.loginType = "";
			state.ShowNotification = false;
			state.ClientIP = "";
			state.PollAns = [{ id: "", ans: "" }];
			state.MappedEvent = [];
			state.eventCount = 0;
			state.IsMouseCursorEnabled = false;
			state.AgoraPlayerBrowserSupportInIPad = false;
			state.AgoraPlayerBrowserSupportInMobile = false;
			state.currentLoginTime = null;
			state.isClientEventBrandingEnabled = false;
			state.brandingJsonUrl = null;
			state.totalExpoBoothCount = 0;
			state.previewLogin = null;
			state.DefaultChatRoomId = null;
			state.videoPlaySettings = null;
			state.fbAccessToken = "";
			state.tempAdminEvent = {};
			state.token = "";
			document.cookie = "userid=";
			state.isSSO = false;
			state.RouteName = "";
			localStorage.removeItem("my-app");
		}
	},
	getters: {
		getStageViewChat(state) {
			return state.IsStageChatEnabled;
		},
		getSocialShareImage(state) {
			return state.SocialShareImage;
		},
		getDefaultLandingPage(state) {
			return state.DefaultLandingPageInsideEvent;
		},
		getClonedTemplateMasterDetails(state) {
			return state.clonedTemplateMasterDetails;
		},
		getBlukUploadProgress(state) {
			return state.bulkUploadProgress;
		},
		getAdminTour(state) {
			return state.adminTourSeen;
		},
		getCustomDomain(state) {
			return state.customDomain;
		},
		getTempAdminEvent(state) {
			return state.tempAdminEvent;
		},
		getFbAccessToken(state) {
			return state.fbAccessToken;
		},
		getVideoPlaySettings(state) {
			return state.videoPlaySettings;
		},
		getDefaultRoomId(state) {
			return state.DefaultChatRoomId;
		},
		getIsAccessCodeLogin(state) {
			return state.IsAccessCodeLogin;
		},
		getPreviewLoginFlag: state => {
			return state.previewLogin;
		},
		getExhibitorBoothCount: state => {
			return state.totalExpoBoothCount;
		},
		getloggedInDeviceToken: state => {
			return state.loggedInDeviceToken;
		},
		getClickToJoinText: state => {
			return state.ClickToJoinText;
		},
		getEventBannerRedirect: state => {
			return state.EventBannerRedirect;
		},
		getEventFont: state => {
			return state.EventFont;
		},
		getUser: state => {
			if (state.user && state.user.length > 0) {
				return state.user[0];
			}
			else {
				return null;
			}
		},
		getUserData: state => {
			var filtered = state.user.filter(function (el) {
				return el.Email !== "";
			});
			return filtered;
		},
		getUserId: state => {
			var userId = ""
			if (state.user && state.user && state.user.length && state.user[0].id) {
				userId = state.user[0].id;
			}
			return userId;
		},
		getUserRoles: state => {
			return state.userRole;
		},
		getAdminRoles: state => {
			return state.AdminRoles;
		},
		getClient: state => {
			var filtered = state.client.filter(function (el) {
				return el.id !== "";
			});
			return filtered;
		},
		getClientId: state => {
			if (state.client && state.client.length > 0) {
				return state.client[0].id;
			}
			else {
				return ""
			}
		},
		getEvent: state => {
			return state.eventid;
		},
		getMappedEvent: state => {
			if (state.MappedEvent) {
				return state.MappedEvent;
			}
			else {
				return [];
			}
		},
		getBranding: state => {
			return state.branding;
		},
		getEventBranding: state => {
			return state.EventBranding;
		},
		getSocialAuth: state => {
			var filtered = state.socialauth.filter(function (el) {
				return el.fb !== "";
			});
			return filtered;
		},
		getEventCollectionName: state => {
			var collectionName = ""
			if (state.eventcollectionname) {
				collectionName = state.eventcollectionname;
			}
			return collectionName;
		},
		getPublicEventCollection: state => {
			var collectionName = ""
			if (state.publicEventCollection) {
				collectionName = state.publicEventCollection;
			}
			return collectionName;
		},
		getAttendee: state => {
			return state.attendeeid;
		},
		getEventName: state => {
			return state.eventname;
		},
		getCurrentEvent: state => {
			return state.historyEvent;
		},
		getEventSdate: state => {
			return state.eventsdate;
		},
		getEventEdate: state => {
			return state.eventedate;
		},
		getSelExhibitor: state => {
			return state.selExhibitorID;
		},
		getUserChatLanguage: state => {
			return state.userChatLanguage;
		},
		getSelSponsor: state => {
			return state.selSponsorID;
		},
		getZone: state => {
			return state.tzone;
		},
		getExbList: state => {
			return state.exbList;
		},
		getNavProtectedExbList: state => {
			return state.navProtectedExbList;
		},
		getLoading: state => {
			return state.loading;
		},
		getToken: state => {
			return state.token;
		},
		getCurrentLoggedInTime: state => {
			return state.currentLoginTime;
		},
		getClientEventBrandingEnabled: state => {
			return state.isClientEventBrandingEnabled;
		},
		getBrandingJsonUrl: state => {
			return state.brandingJsonUrl;
		},
		getClientIP: state => {
			return state.ClientIP;
		},
		getEnableSelfService: state => {
			var result = false;
			if (state.EnableSelfService && state.EnableSelfService == true) {
				result = true;
			}
			return result;
		},
		getRouteName: state => {
			return state.RouteName;
		},
	},
	actions: {
		changeLocale({ commit }, newLocale) {
			// vue-i18n 9: the active locale lives on i18n.global.locale
			(i18n.global as any).locale = newLocale;
			commit("updateLocale", newLocale);
		}
	},
	modules: {},
	plugins: [vuexPersist.plugin],
	strict: false
});
